// Contingents (tkt-backend docs/CONTINGENTS.md): an event's tickets set aside for stakeholders, and the
// ledger that moves them. The contractor's screens (modules/venue-port/features/contingents), run as written
// (tkt/ContingentsRoutes.jsx). Event-scoped through ?event= (lib/useGlobalEventFilter). Where contingents are
// not run (lib/accessGating contingentsEnabled: MoMo) the address goes to the dashboard.
import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { contingentsEnabled } from '../lib/accessGating';
import { ContingentsLandingRoute } from '../modules/venue-port/tkt/ContingentsRoutes';

export const Route = createFileRoute('/contingents/')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: () => {
    if (!contingentsEnabled()) throw redirect({ to: '/', replace: true });
  },
  component: () => <ContingentsLandingRoute />,
});
